class FlagPanel extends BaseClass {
    constructor(element, options = {}) {
        super(element);
        this.options = options;

        this.defaultOptions = {
            inputSelector: 'input'
        };

        this.finalOptions = {...this.defaultOptions, ...this.options};

        this.bindStart();
    }

    bindStart() {

        this.element.addEventListener('click', () => {
            this.init();
            this.bindEvents();
            this.setChecked();
        }, {
            once: true
        });

    }

    init() {

        this.items = this.element.querySelectorAll(this.finalOptions.inputSelector);
        this.element.classList.add('loaded');

    }

    bindEvents() {

        this.items.forEach(el => {
            el.addEventListener('input', () => this.setChecked());
        });

        window.addEventListener("resize", () => this.setChecked());

    }

    setChecked() {

        let checkedItem;

        this.items.forEach(el => {
            if (el.checked !== false) checkedItem = el;
        })

        const relatedPane = checkedItem.nextElementSibling;

        const boundingBoxLeft = (this.element.getClientRects().length === 0) ? 0 : (this.element.getClientRects()[0].left + 1);

        const paneArea = {
            left: relatedPane.getClientRects()[0].left,
            width: relatedPane.getClientRects()[0].width
        }

        this.element.style.setProperty('--left', `${paneArea.left - boundingBoxLeft}px`);
        this.element.style.setProperty('--width', `${paneArea.width}px`);

    }

}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-flag-panel]').forEach(el => {
        let flagPanel = new FlagPanel(el);
        el.classFunc = flagPanel;
    });
});